<template>
  <div
    class="phase-operations-complex"
    :style="module.containerStyle"
    :data-tangram-module-id="module.id"
  >
    <div class="scroll-view">
      <div class="stage-operation-wrapper">
        <div
          v-if="module.data.otherData.img"
          class="activity-adv"
          @click="toLink"
        >
          <img
            :src="
              ossImage({
                src: module.data.otherData.img,
                width: 750,
                height: 0
              })
            "
            class="img"
            @error="imgLoadFail"
          />
          <div v-if="module.data.h5_url" class="activity-rules">活动规则</div>
        </div>
        <ul class="steps" :style="style">
          <operation-step
            v-for="(item, index) in module.data.stageDescDtoList"
            :key="index"
            :stage-info="item"
          />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { ossImage } from '@/utils/oss_image'
import { imgLoadFail } from '@/utils/utils'

import OperationStep from '../components/OperationStep'

export default {
  name: 'PhaseOperationsComplex',
  components: {
    OperationStep
  },
  props: {
    module: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    style() {
      return {
        backgroundImage: this.module.backgroundImage
          ? `url(${this.module.backgroundImage})`
          : this.module.backgroundColor
      }
    }
  },
  methods: {
    ossImage,
    imgLoadFail,
    toLink() {
      if (!this.module.data.otherData.action) return
      this.$autoRedirect(this.module.data.otherData.action.payload)
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-adv {
  position: relative;
  .img {
    width: 100%;
  }
  .activity-rules {
    display: flex;

    position: absolute;
    top: 1.4rem;
    right: 0;

    width: 1.18rem;
    height: 0.5rem;

    background: rgba(255, 255, 255, 0.2);
    border-radius: 0.26rem 0 0 0.24rem;

    justify-content: center;
    align-items: center;

    font-size: 0.24rem;
    color: #ffffff;
  }
}
.steps {
  padding: 0.4rem 0.26rem 1px;
  background-size: 100%;
}
</style>
